module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/webpolls/bravenet_webpolls_easy_to_use.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/webpolls/bravenet_webpolls_easy_to_use.png
// module id = P0x9
// module chunks = 0